module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Help")]), _vm._v(" "), _vm._l((_vm.questions), function(answers, question) {
    return _c('div', {
      staticClass: "flexRow faq"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("\n      " + _vm._s(question) + "\n    ")]), _vm._v(" "), _c('ul', _vm._l((answers), function(answer) {
      return _c('li', [_vm._v("\n        " + _vm._s(answer) + "\n      ")])
    }), 0)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-417eb9f0!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/HelpView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-417eb9f0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/HelpView.vue
// module chunks = 0